import React from "react";
import { Button, Modal, HelpBlock, Notification } from "rsuite";
import { DatePickerComponent } from "../../../formfields/DatePicker";
import dayjs from "dayjs";
import axios from "../../../../utilities/axios";
import { AxiosResponse } from "axios";
import { AxiosSelectPicker } from "../../../formfields/AxiosSelectPicker";

interface optionsFormValues {
    field: string;
    value: string;
}

interface ModalExportProps {
    showModal: boolean;
    onClose: () => void;
}

interface ModalExportState {
    attributes: {
        created_at: optionsFormValues,
        finally_at: optionsFormValues,
        accounting_parameter_id: number
    }
    loading: boolean;
    data: any[]
}

export class ModalExportHours extends React.Component<ModalExportProps, ModalExportState> {
    state: ModalExportState = {
        attributes: {
            created_at: {
                field: "import_hour_journey_day",
                value: dayjs().subtract(30, 'days').format('YYYY-MM-DD HH:mm:ss.sss')
            },
            finally_at: {
                field: "import_hour_journey_day",
                value: dayjs().format('YYYY-MM-DD HH:mm:ss.sss')
            },
            accounting_parameter_id: 0
        },
        loading: false,
        data: []
    }

    onChangeInput = (params: { value: any, alias: string }) => {
        const { value, alias } = params;
        this.setState(
            (prevState) => ({
                attributes: {
                    ...prevState.attributes, 
                        accounting_parameter_id: alias === 'accounting_parameter_id' ? value : prevState.attributes.accounting_parameter_id,
                    [alias]: 
                            { 
                              value: value, 
                          
                            }
                }
            }),
        );
    }


    onCreatedExport = () => {
        this.setState({ loading: true })
        axios
            .get('/api/v1/autotrack/generate-txt', {
                params: {
                    attributes: {
                        ...this.state.attributes
                    }
                }
            })
            .then((response: AxiosResponse<{
                status: number,
                message: string,
                error: boolean,
                downloadUrl: string,
            }>) => {
                const { message, downloadUrl, error } = response.data;

                if (!error){
                    Notification.success(
                        {
                            title: "SUCESSO!!!",
                            description: message
                        }
                    )
                } else {
                    Notification.error(
                        {
                            title: "ERRO!!!",
                            description: message
                        }
                    )
                }
                
                if (downloadUrl) {
                    const url: any = downloadUrl.split('./').pop()
                    const fileName = url.split('/').pop();
                    const downloadLink = document.createElement('a');
                    downloadLink.href = 'https://' + window.location.host.split('25565').join('25567') + `/${url}`;
                    downloadLink.setAttribute('download', fileName);
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    document.body.removeChild(downloadLink);
                }
            })
            .finally(() => {
                this.setState({ loading: false })
            })
    }
    onClose = () => {
      this.props.onClose();  
    }

    render(): React.ReactNode {
        return (
            <>
                <Modal
                    show={this.props.showModal}
                >
                    <Modal.Header
                        closeButton={false}
                    >
                        <h5>
                            Exclusivo para exportação de dados
                        </h5>
                    </Modal.Header>
                    <Modal.Body
                        style={
                            {
                                marginTop: 10,
                                display: "flex",
                                flexDirection: "column",
                                gap: 5,
                            }
                        }
                    >
                        <div>
                            <label>
                                Selecione a Contabilidade
                            </label>
                            <div>
                                <AxiosSelectPicker 
                                    data={this.state.data}
                                    api={
                                        {
                                            method: "GET",
                                            url: "/api/v1/accounting_parameters/select"
                                        }
                                    }
                                    onChange={(value: string, e: any) => {
                                        if (value) {
                                            this.onChangeInput(
                                                {
                                                    alias: 'accounting_parameter_id',
                                                    value: value,
                                                }
                                            )
                                        }
                                    }}
                                    value={this.state.attributes.accounting_parameter_id}
                                    
                                />
                                
                            </div>
                            <HelpBlock>obrigatório*</HelpBlock>
                        </div>
                        <div
                            style={
                                {
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    gap: 5
                                }
                            }
                        >
                            <div
                                style={
                                    {
                                        width: "100%",
                                    }
                                }
                            >
                                <label>Data de Inicio</label>
                                <DatePickerComponent 
                                    value={new Date(this.state.attributes.created_at.value)}
                                    onChange={(value: any) => {
                                        this.onChangeInput(
                                            {
                          
                                                value: value,
                                                alias: "created_at"
                                            }
                                        )
                                    }}
                                />
                            </div>
                            <div
                                style={
                                    {
                                        width: "100%"
                                    }
                                }
                            >
                                <label>Data de Finalização</label>
                                <DatePickerComponent
                                    value={new Date(this.state.attributes.finally_at.value)}
                                    onChange={(value: any) => {
                                        this.onChangeInput(
                                            {
                                                value: value,
                                                alias: "finally_at"
                                            }
                                        )
                                    }}
                                />
                            </div>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        
                        <Button
                            color="red"
                            loading={this.state.loading}
                            onClick={this.onClose}
                        >
                            Cancelar Exportação
                        </Button>
                        <Button
                            color="green"
                            onClick={this.onCreatedExport}
                            loading={this.state.loading}
                        >
                            Exportar TXT
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        )
    }
}